import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  summaryWrapper: {
    display: 'flex',
    flexDirection: 'column',
  },
  fontBolded: {
    fontWeight: 600,
  },
  divider: {
    margin: '2rem 0px 0px',
    width: '100%',
  },
  paddedDivider: {
    margin: '1.5rem 0px',
    width: '100%',
  },
  buttonStyles: {
    borderRadius: '50px',
    height: '40px',
    fontSize: '16px',
    fontWeight: '700',
    textTransform: 'none',
    backgroundColor: theme.palette.primary.lightest,
  },
  altButtonStyle: {
    borderRadius: '50px',
    height: '40px',
    fontSize: '16px',
    fontWeight: '700',
    textTransform: 'none',
  },
  details: {
    marginRight: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  mobileAvatar: {
    border: '2px solid #DBD2C1',
    boxShadow: '0 0 0 7px #FFFFFF, 0px 4px 36px rgba(0, 10, 22, 0.13)',
    width: '3.3rem',
    height: '3.3rem',
  },
  icons: {
    color: theme.palette.secondary.dark,
  },
  attributes: {
    color: theme.palette.grey.dark,
    fontWeight: 600,
  },
  coachCardName: {
    marginLeft: theme.spacing(2),
  },
  seeMoreToggle: {
    color: theme.palette.primary.light,
  },
  summaryDetails: {
    fontWeight: 500,
    color: theme.palette.grey.dark,
    margin: '1rem 0',
  },
}))
